import firecrawlLogo from "@/src/assets/images/neutral/companies/firecrawl.svg";
import agoraLogo from "@/src/assets/images/neutral/companies/agora.svg";
import spatialchatLogo from "@/src/assets/images/neutral/companies/spatialchat.svg";
import medibuddyLogo from "@/src/assets/images/neutral/companies/medibuddy.svg";
import googleLogo from "@/src/assets/images/neutral/companies/google.svg";
import ayrEnergyLogo from "@/src/assets/images/neutral/companies/ayr_energy.svg";
import ansysLogo from "@/src/assets/images/neutral/companies/ansys.svg";
import veebaLogo from "@/src/assets/images/neutral/companies/veeba.svg";
import testmuAiLogo from "@/src/assets/images/neutral/companies/testmu_ai.svg";
import appsentinelsLogo from "@/src/assets/images/neutral/companies/appsentinels.svg";
import gliderLogo from "@/src/assets/images/neutral/companies/glider.svg";

export const trustedCompanies = [
  { name: "Firecrawl", logo: firecrawlLogo },
  { name: "Agora", logo: agoraLogo },
  { name: "SpatialChat", logo: spatialchatLogo },
  { name: "MediBuddy", logo: medibuddyLogo },
  { name: "Google", logo: googleLogo },
  { name: "AYR Energy", logo: ayrEnergyLogo },
  { name: "Ansys", logo: ansysLogo },
  { name: "VEEBA", logo: veebaLogo },
  { name: "TestMu AI", logo: testmuAiLogo },
  { name: "AppSentinels", logo: appsentinelsLogo },
  { name: "Glider", logo: gliderLogo },
];
